<script>
import Details from "@/router/views/property/components/details";
import AssignmentHistory from "@/router/views/property/components/assignmenthistory";
import InspectionHistory from "@/router/views/property/components/inspectionhistory";
import Attachments from "@/router/views/property/components/attachments";
import RawData from "@/components/widgets/raw-data.vue";

export default {
    props: {
        filter: {
            type: String,
            default: "",
        },
        accountableRow: {
            type: Object,
            required: true,
        },
        assignmentHistoryEmployeeData: {
            type: Array,
            default: () => [],
        },
        assignmentHistoryLocationData: {
            type: Array,
            default: () => [],
        },
        type: {
            type: String,
            default: "inventory",
        },
        viewFrom: {
            type: String,
            default: "supply",
        },
    },
    components: {
        Details,
        AssignmentHistory,
        InspectionHistory,
        Attachments,
        RawData,
    },
    data() {
        return {
            currentPage: 1,
            perPage: 10,
        };
    },
    computed: {
        propertyItems() {
            if (this.type == "inventory") {
                return this.accountableRow.item.properties;
            }
            return this.accountableRow.item.items;
        },
        filtered() {
            let data = this.propertyItems;
            var total = this.currentPage * this.perPage;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey.toUpperCase().includes(this.filter.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        rows() {
            let data = this.propertyItems;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey.toUpperCase().includes(this.filter.toUpperCase());
                });
            }
            return data.length;
        },
        selectAll: {
            get() {
                return this.filtered.every((property) => property.toggleSelected);
            },
            set(value) {
                this.filtered.forEach((property) => {
                    property.toggleSelected = value;
                });
            },
        },
    },
    methods: {
        propertyNumberWidth(number) {
            if (number < 100) return "min-width: 35px";
            else if (number < 1000) return "min-width: 50px";
            else if (number < 10000) return "min-width: 60px";
            else return "min-width: 75px";
        },
        checkAll(event) {
            this.filtered.forEach((property) => {
                this.$emit('checkToggle', { property, parent: this.accountableRow.item, checkEvent: event });
            });
        }
    }
}
</script>
<template>
    <div>
        <div class="d-flex justify-content-between px-3 py-2 align-items-center">
            <div class="form-check form-checkbox-outline form-check-success me-2"
                v-if="type == 'inventory' || type == 'notbooked'">
                <input type="checkbox" :id="`select-all-${type}`" class="form-check-input" v-model="selectAll"
                    @change="checkAll($event)" />
                <label class="form-check-label" :for="`select-all-${type}`">
                    Select All
                </label>
            </div>
            <div class="d-flex align-items-center">
                <select class="form-select form-select-sm" v-model="perPage">
                    <option>10</option>
                    <option>25</option>
                    <option>50</option>
                    <option>100</option>
                </select>
            </div>
        </div>
        <div class="ms-3 position-relative" v-for="(property, propertyIndex) in filtered" :key="property.id">
            <RawData :data="property" v-if="$store.state.decrypt.isAdmin()" />
            <b-card-header header-tag="header" role="tab" class="border">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center pe-5">
                        <div style="width: 25px" class="form-check form-checkbox-outline form-check-success me-2"
                            v-if="type == 'inventory' || type == 'notbooked'">
                            <input type="checkbox" :id="`apiID-${property.id}`" class="form-check-input"
                                @change="$emit('checkToggle', { property, parent: accountableRow.item, checkEvent: $event })"
                                v-model="property.toggleSelected" />
                        </div>
                        <div :style="propertyNumberWidth(propertyIndex + 1)"
                            class="bg-success bg-gradient text-center me-2 py-1 position-relative">
                            <h3 class="mb-0 position-relative text-white">
                                {{ propertyIndex + 1 }}
                            </h3>
                        </div>
                        <div class="text-muted">
                            <h5 class="mb-0">
                                {{ property.name || property.propertyName }}
                            </h5>
                            <div style="min-width: max-content">
                                <small class="d-flex align-items-center">
                                    <template v-if="property.propertyNumber">
                                        {{ property.propertyNumber != "Not Indicated" ? `Property#
                                        ${property.propertyNumber}` : "Not Indicated" }}
                                    </template>
                                    <template v-if="type == 'inventory'">
                                        |
                                        <a href="javascript: void(0);"
                                            class="text-success d-flex align-items-center ms-1"
                                            @click="property.visible = !property.visible">
                                            {{ property.visible ? "Hide" : "Show" }} Details
                                            <i class="bx bx-chevron-right rotate font-size-14" :class="{
                                                'rotate-90':
                                                    property.visible,
                                            }"></i>
                                        </a>
                                    </template>
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center ms-5" v-if="type == 'inventory'">
                        <div style="width: 200px" class="d-flex align-items-center">
                            <div class="text-muted">
                                <small> Condition: </small>
                                <div>{{ property.condition }}</div>
                            </div>
                        </div>
                        <div v-if="viewFrom != 'finance'" style="width: 110px" class="d-flex align-items-center">
                            <div class="text-muted">
                                <div><small> Found in Station:</small></div>
                                <div class="form-check form-switch cursor-pointer">
                                    <input class="form-check-input" type="checkbox" :id="`switch-${property.id}`"
                                        v-model="property.foundInStation"
                                        @change="$emit('changePropertyStatus', { id: property.id, foundInStation: property.foundInStation })" />
                                    <label class="form-check-label" :for="`switch-${property.id}`">
                                        {{ property.foundInStation ? "Yes" : "No" }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div v-if="viewFrom == 'finance'" style="width: 110px" class="d-flex align-items-center">
                            <div class="text-muted">
                                <div><small> Booked:</small></div>
                                <div class="form-check form-switch cursor-pointer">
                                    <input class="form-check-input" type="checkbox" :id="`booked-${property.id}`"
                                        v-model="property.booked"
                                        @change="$emit('changeBookedStatus', { id: property.id, booked: property.booked })" />
                                    <label class="form-check-label" :for="`booked-${property.id}`">
                                        {{ property.booked ? "Yes" : "No" }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div style="width: 150px" class="d-flex align-items-center">
                            <div v-if="property.note && property.note.trim() != ''" class="text-muted">
                                <small>Remark:</small>
                                <div><small>{{ property.note }}</small></div>
                            </div>
                        </div>
                        <div v-if="viewFrom != 'finance'" class="float-end d-flex align-items-center ms-3">
                            <i class="bx bx-printer font-size-18 text-purple cursor-pointer ms-2"
                                :id="`inventory-property-print-popover-${property.id}`" tabindex="0"></i>
                            <b-popover :target="`inventory-property-print-popover-${property.id}`" triggers="click blur"
                                placement="leftbottom" variant="secondary" custom-class="p-0">
                                <b-list-group class="w-100 fit">
                                    <b-list-group-item v-if="property.amount >= 50000" button action
                                        class="d-flex align-items-center"
                                        @click="$emit('printParProperty', property.propertyId)">
                                        <i class="bx bx-printer text-purple font-size-18 me-1"></i>
                                        Print PAR
                                    </b-list-group-item>
                                    <b-list-group-item v-else button action class="d-flex align-items-center"
                                        @click="$emit('printIcsProperty', property.propertyId)">
                                        <i class="bx bx-printer text-purple font-size-18 me-1"></i>
                                        Print ICS
                                    </b-list-group-item>
                                    <b-list-group-item button action class="d-flex align-items-center"
                                        @click="$emit('printStickerProperty', property.propertyId)">
                                        <i class="bx bx-printer text-purple font-size-18 me-1"></i>
                                        Print Sticker
                                    </b-list-group-item>
                                    <b-list-group-item button action class="d-flex align-items-center"
                                        @click="$emit('printPropertyCard', property.propertyId)">
                                        <i class="bx bx-printer text-purple font-size-18 me-1"></i>
                                        Print Property Card
                                    </b-list-group-item>
                                </b-list-group>
                            </b-popover>
                            <i class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                                :id="`inventory-property-popover-${property.id}`" tabindex="0"></i>
                            <b-popover :target="`inventory-property-popover-${property.id}`" triggers="click blur"
                                placement="leftbottom" variant="secondary" custom-class="p-0">
                                <b-list-group class="w-100 fit">
                                    <b-list-group-item button action class="d-flex align-items-center text-info"
                                        @click="$emit('updateItem', property)">
                                        <i class="mdi mdi-update font-size-18 me-1"></i>
                                        Update Item
                                    </b-list-group-item>
                                    <b-list-group-item button action class="d-flex align-items-center text-danger"
                                        @click="$emit('deleteItem', property)">
                                        <i class="mdi mdi-trash-can font-size-18 me-1"></i>
                                        Remove Item
                                    </b-list-group-item>
                                </b-list-group>
                            </b-popover>
                        </div>
                    </div>
                </div>
            </b-card-header>
            <b-collapse :visible="property.visible" role="tabpanel">
                <div v-if="property.visible">
                    <b-card no-body class="shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0">
                        <Details :key="`search-details-${property.id}`" :propertyRow="property"
                            :ref="`search-details-${property.id}`" />
                        <AssignmentHistory :key="`search-assignment-${property.id}`" :propertyRow="property"
                            :allowAssign="false" :allowEdit="true" :allowTransfer="true"
                            :employeeData="assignmentHistoryEmployeeData" :locationData="assignmentHistoryLocationData"
                            :ref="`search-assignment-${property.id}`" @getEmployee="$emit('getEmployee', $event)"
                            @getLocation="$emit('getLocation', $event)" />
                        <InspectionHistory :key="`search-inspection-${property.id}`" :propertyRow="property"
                            :ref="`search-inspection-${property.id}`" />
                        <Attachments :key="`search-attachments-${property.id}`" :propertyRow="property"
                            :ref="`search-attachments-${property.id}`" />
                    </b-card>
                </div>
            </b-collapse>
        </div>
        <div class="row mt-3 mb-2">
            <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>